import React, { useState } from "react";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="relative flex justify-between items-center text-black py-4 px-4 lg:px-24 shadow-2xl">
      <a href="/">
        <img
          src="/images/logo/mosa-logo.png"
          alt="logo mosa"
          className="w-16 h-16 lg:w-24 lg:h-24"
        />
      </a>

      <button
        className="absolute top-8 right-5 lg:hidden focus:outline-none transition-all duration-300 ease-in-out"
        onClick={toggleMenu}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
          ></path>
        </svg>
      </button>

      <nav
        className={`z-1 absolute top-full left-0 w-full bg-white overflow-hidden lg:static lg:hidden lg:w-auto transition-all duration-300 ease-in-out ${
          isMenuOpen ? "max-h-screen" : "max-h-0"
        }`}
      >
        <ul
          className={`flex flex-col lg:flex-row lg:justify-center lg:items-center font-bold text-base mt-4 lg:mt-0 transform-gpu transition-transform duration-500 ease-in-out pl-4 pb-4 ${
            isMenuOpen ? "scale-y-100" : "scale-y-0"
          } origin-top`}
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/">🏠 ACCUEIL</a>
          </li>
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/apropos">🧑‍💼 QUI SOMMES NOUS ?</a>
          </li>
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/metier">🏗️ NOS METIERS</a>
          </li>
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/references">🗂️ RÉFÉRENCES</a>
          </li>
          <li className="mt-2 lg:mt-0 text-white bg-[#0A827D] rounded-2xl py-2 px-4 lg:py-2 lg:px-5 hover:bg-[#05736e] transition-all duration-200 hover:scale-105 ease-in-out shadow-xl">
            <a href="/contact">✉️ CONTACT</a>
          </li>
        </ul>
      </nav>
      <nav className=" hidden absolute top-full left-0 w-full bg-white overflow-hidden lg:static lg:block lg:w-auto transition-all duration-300 ease-in-out">
        <ul
          className="z-6 flex flex-col lg:flex-row lg:justify-center lg:items-center font-bold text-base mt-4 lg:mt-0"
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/">🏠 ACCUEIL</a>
          </li>
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/apropos">🧑‍💼 QUI SOMMES NOUS ?</a>
          </li>
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/metier">🏗️ NOS METIERS</a>
          </li>
          <li className="mx-2 lg:mx-5 py-2 hover:border-b-4 transition-all border-[#0A827D]">
            <a href="/references">🗂️ RÉFÉRENCES</a>
          </li>
          <li className="z-6 mt-2 lg:mt-0 text-white bg-[#0A827D] rounded-2xl py-2 px-4 lg:py-2 lg:px-6 lg:mr-4 hover:bg-[#05736e] transition-all duration-200 hover:scale-105 ease-in-out shadow-xl">
            <a href="/contact">✉️ CONTACT</a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
